import React, { FormEvent, memo, RefObject, forwardRef } from 'react';
import { Input } from '@tidbits/react-tidbits';

interface ComponentProps {
  onInputChange(event: FormEvent<HTMLInputElement>): void;
  searchValue: string;
  placeholder: string;
  ref: RefObject<HTMLDivElement>;
}

interface TextProps {
  value?: string;
  onChange?: () => void;
  iconName?: string;
}

type Props = ComponentProps & TextProps;

const SearchInputField = forwardRef<HTMLDivElement, Props>(({
  onInputChange,
  searchValue,
  placeholder,
  iconName,
}, ref) => {

  return (
    <Input.Text
      IconComponent={iconName}
      type="text"
      value={searchValue}
      onChange={onInputChange}
      id="searchInput"
      className="ui-components-search__input"
      placeholder={placeholder}
      clearable={true}
      width={'200px'}
      ref={ref}
    />
  );
})

export default memo(SearchInputField);